var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetronome = function SvgMetronome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.262 19.725 14.731 4.99c-.77-1.33-2.691-1.33-3.462 0L2.738 19.725c-.772 1.333.19 3.002 1.73 3.002h17.063c1.54 0 2.503-1.669 1.731-3.002Z",
    stroke: "#8B8C8E",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18h18",
    stroke: "#8B8C8E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-fill-active": "true",
    d: "M3.855 6.857a.907.907 0 0 0-1.275-.071.893.893 0 0 0-.071 1.267l1.346-1.196ZM2.509 8.053l9.818 10.908 1.346-1.196L3.855 6.857 2.509 8.053Z",
    fill: "#8B8C8E"
  })));
};
export default SvgMetronome;